export default __webpack_public_path__ + "media/src/assets/fonts/Bitter-Bold-1faea0961beaedddd51ba829a606664b.ttf";